<template>
    <transition name="modal-fade">
        <div class="modal-overlay" @click="$emit('close-modal')">
            <div class="modal-content" @click.stop>

                <form class="row" style="padding:20px;">
                    <div class="col-12 title " style="color: #c3e353; font-weight:500 !important; font-size:14px; text-align:left;">Name your new project</div>
                    <div class="col-12">
                        <input type="text" class="form-control" v-model="Project.Name" placeholder="Ex 2315 Beverley Ave" style="border-radius: 2px !important;">
                    </div>

                    <div class="col-12" style="margin-top:20px;">
                        <textarea type="text" class="form-control" v-model="Project.Comments" placeholder="Comments" style="height:150px; border-radius:2px !important;" />
                    </div>

                    <div class="col-12" style="text-align: right; margin-top: 8px; background-color: #132338; ">

                        <div class="btn btn-negative" @click="$emit('close-modal')" style="margin-right: 8px; display: block; width: 100%; height:38px; line-height:38px; color:white;">Cancel</div>
                        <div class="btn btn-positive" @click="save" style="display: block; width: 100%; height: 38px; line-height: 38px;">Save project</div>

                    </div>

                </form>
                <div class="row">
                    
                </div>
                 
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {
        data() {
            return {
                Project: { Name: '', Comments: '' }

            }
        },
        methods: {
            save() {
                if (this.Project.Name.length == 0) {
                    //this.$alert("Please input the project name.", "Error");
                    this.$ui.alert(this, "Error", "Please input the project name.", "error");


                    return;
                }


                this.$core.AddProject(this.Project).then((data) => {
                     
                    
                    if (data.Message!='') {
                        this.$ui.alert(this, "Error", data.Message, "error");
                    } else {
                        this.Project.Name = '';
                        this.Project.Comments = '';
                        this.$emit('save');
                    }

                });
            }
        }
    }
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #00000088;
    }

    .modal-content {
        text-align: center;
        background-color: #132338;
        height: 420px;
        width: 300px;
        margin-top: 10%;
        overflow: hidden;
    }

     

    .check {
        width: 150px;
    }

    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }
</style>